import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=bc5e43bc&scoped=true&"
import script from "./Interview.vue?vue&type=script&lang=ts&"
export * from "./Interview.vue?vue&type=script&lang=ts&"
import style0 from "./Interview.vue?vue&type=style&index=0&id=bc5e43bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5e43bc",
  null
  
)

export default component.exports